import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './slice/authSlice';
import cartReducer from './slice/cartSlice';
// import userReducer from './slice/userSlice'; // Add more slices as needed

const rootReducer = combineReducers({
  auth: authReducer,
  cart: cartReducer,
  // user: userReducer,
});

// export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
